import colivingblog from '../../images/colivingblog.jpg'

export const blogs = 
  {
    title: 'La gente que vive en ‘coliving’ tiene niveles más altos de felicidad',
    subtitle: 'Experience the world through' ,
    description: 'El coliving es un bonito equilibrio entre el espacio privado y espacios compartidos con una serie de reglas y normas dentro de cada comunidad. La pandemia nos mostró lo solitario que es estar encerrados en nuestros pisos; queremos estar conectados con los demás y el coliving es un modelo de éxito.', 
    description2: 'La gente es más feliz y afirman tener un nivel de bienestar mayor consumiendo menos, con una huella ecológica menor. Mucha gente piensa que más es la clave para vivir mejor, pero estudios como el de Harvard –un estudio que está en marcha desde hace 70 años– subrayan que la satisfacción está en las relaciones con otras personas',
    picture: colivingblog, 
    pictureLabel: 'string'
  }